import { GetAsinMetadataInput, AsinMetadataEntry, useGetPrsDataQuery } from '@graphql/generated/graphql';

const useGetPrsDataResult = (input: GetAsinMetadataInput) => {
  const { ...restInput }: GetAsinMetadataInput = input;

  const { data, isSuccess, error } = useGetPrsDataQuery({
    input: {
      ...restInput,
    },
  });
  const asinMetadataList: AsinMetadataEntry[] | undefined | null = data?.getAsinMetadata.asinMetadata;
  const queryError: Error = error as Error;

  return {
    asinMetadataList,
    isSuccess,
    error: queryError,
  };
};

export default useGetPrsDataResult;
